import React from 'react'
import StopsIndex from '../features/stops'
function StopsPage() {
  return (
    <StopsIndex />
  )
}

export default StopsPage